import { Link } from 'react-router-dom';
import { latestComics, Comic } from '@/mocks/comics';

export default function LatestUpdates() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-secondary-50/50">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-800">
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日新鲜漫画，精彩不容错过</p>
          </div>
          <Link
            to="/category/tuijian"
            onClick={scrollToTop}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} scrollToTop={scrollToTop} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ComicCard({ comic, scrollToTop }: { comic: Comic; scrollToTop: () => void }) {
  const categoryMap: Record<string, string> = {
    hanman: '韩漫',
    riman: '日漫',
    guoman: '国漫',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      onClick={scrollToTop}
      className="group bg-background-50 rounded-xl overflow-hidden border border-secondary-200/60 hover:border-primary-300 transition-all duration-300 hover:scale-[1.02]"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 43423漫画网`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-white'
              : 'bg-accent-500 text-white'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-black/60 text-white backdrop-blur-sm">
            {categoryMap[comic.category] || '漫画'}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2 text-white/90 text-xs">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span>{comic.rating}</span>
            <span className="text-white/50">·</span>
            <i className="ri-eye-line text-xs"></i>
            <span>{(comic.views / 10000).toFixed(1)}万</span>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-800 line-clamp-1 mb-1 group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-400 mb-2">{comic.author}</p>
        <div className="flex items-center gap-2">
          <span className="text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full">
            {comic.latestChapter}
          </span>
          <span className="text-[10px] text-foreground-400">{comic.updateTime}</span>
        </div>
      </div>
    </Link>
  );
}